<template>
  <v-slide-y-transition>
    <v-container
      v-show="item.show">
      <v-layout justify-center align-center>
        <v-card
          v-if="item.payload === null"
          width="440" height="200" class="file d-flex" align-items="center">
          <v-card-text>
            <v-layout align-center justify-center row fill-height>
              <v-progress-linear color="blue darken-2" v-model="item.progress"/>
              <span class="ml-3 blue--text text--darken-2">{{ item.progress }}%</span>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card
          v-else-if="item.payload !== null && !item.sended"
          width="440" height="200" class="file">
          <v-toolbar height="40">
            <a class="blue--text" :href="item.payload.url" target="_blank">{{ item.file.name }}</a>
            <v-spacer/>
            <v-btn icon @click="removeFile(item)" :loading="loadingRemoveFile">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-layout class="grey--text text--darken-2" align-center>
              <v-icon class="mr-3">{{ fileStateIcon(item.payload.file.mime_type) }}</v-icon>
              <span>{{ fileTypeName(item.payload.file.mime_type) }}</span>
              <v-spacer/>
              <v-btn @click="downloadFile" class="ma-0" icon flat>
                <v-icon color="black">mdi-download</v-icon>
              </v-btn>
            </v-layout>
            <audio id="sound" v-if="isAudio && !isEmpty(item)" controls :src="item.payload.file.url">
              <source :src="item.payload.file.url" :type="item.payload.file.mime_type"/>
            </audio>

            <v-layout>
              <v-autocomplete
                id="teste"
                name="teste"
                @change="onSelectDocumentType"
                :loading="loading"
                v-model="documentType"
                class="my-3"
                solo
                placeholder="Tipo de documento"
                :items="documentTypes"
                item-text="name"
                item-value="id"
                :menu-props="{
                  maxWidth: 400,
                }"
                no-data-text="Tipo de documento não encontrado"
                :search-input.sync="search"
                :hide-no-data="searchIsInvalid"
              />
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card
          v-else
          width="440" height="200" class="file" style="flex-flow: wrap">
          <v-toolbar height="40">
            <a class="blue--text" :href="item.payload.url" target="_blank">{{ item.file.name }}</a>
            <v-spacer/>
            <v-btn icon @click="removeFile(item)" :disabled="true" :loading="loadingRemoveFile">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text fill-height>
            <v-layout align-center  column justify-space-around>
              <v-icon>mdi-check</v-icon>
              <span>Documento Enviado</span>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-layout>
    </v-container>
  </v-slide-y-transition>
</template>

<script>
  import { isEmpty } from 'lodash';
  import documentsService from '@/services/DocumentsService';
  import fileStateIcon from '@/mixins/file-state-icon';
  import fileTypeName from '@/mixins/file-type-name';
  import validationRules from '@/mixins/validation-rules';

  export default {
    name: 'DocumentAttached',
    props: {
      item: {
        type: Object,
      },
      index: {
        type: Number,
      },
    },
    data() {
      return {
        documentType: '',
        documentTypes: [],
        fileStateIcon,
        fileTypeName,
        isEmpty,
        loading: false,
        loadingRemoveFile: false,
        validationRules,
        search: '',
      };
    },
    methods: {
      getDocumentTypes(query) {
        clearTimeout(this.timeout);
        this.loading = true;
        this.timeout = setTimeout(() => {
          documentsService.getDocumentTypes(query)
            .then(({ data }) => {
              this.documentTypes = data;
            })
            .catch((err) => {
              this.onRequestError(err);
            })
            .finally(() => {
              this.loading = false;
            });
        }, 700);
      },
      removeFile(item) {
        this.loadingRemoveFile = true;
        documentsService
          .destroyPDFDocument(item.payload.id)
          .then(() => {
            this.$emit('removeFile');
          })
          .catch((err) => {
            this.$store.dispatch('toggleSnackbar', {
              show: true,
              color: 'error',
              message: err,
              messageIcon: 'mdi-alert-outline',
            });
          })
          .finally(() => {
            this.loadingRemoveFile = false;
          });
      },
      downloadFile() {
        const a = document.createElement('a');
        a.href = this.item.payload.file.url;
        a.target = '_blank';
        a.click();
      },
      onSelectDocumentType(value) {
        this.documentType = value;
        if (this.documentType !== null) {
          this.$emit('setDocumentType', {
            index: this.index,
            documentTypeId: this.documentType,
          });
        }
      },

    },
    computed: {
      isAudio() {
        return (this.item.file.mime_type === 'audio/mpeg' ||
          this.item.file.mime_type === 'application/mp3');
      },
      folder() {
        return this.$store.getters.activeFolder;
      },
      searchIsInvalid() {
        return isEmpty(this.search) || this.search === undefined || this.search.length < 3;
      },
    },
    watch: {
      search(val) {
        if (val !== null && val !== undefined && val.length > 2) {
          this.getDocumentTypes(val);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>

  audio {
    height: 35px;
  }

  .container {
    padding: 0 !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/document/new/DocumentAttached.vue